import React from "react";
import { Form, ButtonGroup, ToggleButton } from "react-bootstrap";
import { RedactionType } from "../../types/shared.types";

interface RedactionTypeSelectorProps {
  value: RedactionType;
  onChange: (value: RedactionType) => void;
  label?: string;
  className?: string;
}

const redactionOptions = [
  {
    value: "names_only" as RedactionType,
    label: "Names Only",
    description: "Redact only personal names",
  },
  {
    value: "providers_only" as RedactionType,
    label: "Providers Only",
    description: "Redact only provider/organization names",
  },
  {
    value: "names_and_providers" as RedactionType,
    label: "Names & Providers",
    description: "Redact both personal and provider names",
  },
];

const RedactionTypeSelector: React.FC<RedactionTypeSelectorProps> = ({
  value,
  onChange,
  label = "Redaction Type",
  className = "",
}) => {
  return (
    <Form.Group className={className}>
      <Form.Label>{label}</Form.Label>
      <div>
        <ButtonGroup className="w-100">
          {redactionOptions.map((option) => (
            <ToggleButton
              key={option.value}
              id={`redaction-${option.value}`}
              type="radio"
              variant={value === option.value ? "primary" : "outline-primary"}
              name="redactionType"
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.currentTarget.value as RedactionType)}
              className="flex-fill"
              title={option.description}
            >
              {option.label}
            </ToggleButton>
          ))}
        </ButtonGroup>
      </div>
      <Form.Text className="text-muted">
        Choose what type of information to redact from your documents
      </Form.Text>
    </Form.Group>
  );
};

export default RedactionTypeSelector;
